import React from 'react';
import LoadSpin from '../LoadSpin/LoadSpin';
import { ReactComponent as CheckIcon } from '../../svg/check.svg';

const OrgType = (props) => {
    return (
        <div className="type-option">
            <h1>{props.title}</h1>
            <hr />
            <div style={{ minHeight: 130, textAlign: 'left', marginTop: 8, marginBottom: 8 }}>
                {props.body?.map((r, index) => {
                    return (
                        <div key={index} style={{ display: 'flex', marginLeft: 16 }}>
                            <CheckIcon />
                            <p>{r}</p>
                        </div>
                    );
                })}
            </div>
            <hr />
            <div className="price">
                <div className="front">
                    <span className="price">&nbsp;</span>
                </div>
                <div className="back">
                    {props.loading ? <LoadSpin /> : <div onClick={props.onClick} className="cbutton">Бүртгүүлэх</div>}
                </div>
            </div>
        </div>
    );
}

export default OrgType;